var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.245,
    height: 30.294,
    viewBox: "0 0 25.245 30.294",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause",
    transform: "translate(-170 -675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause-icon",
    transform: "translate(127.333 675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(42.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_374",
    "data-name": "Grupo 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M50.872,0H44.56a1.9,1.9,0,0,0-1.893,1.893V28.4a1.9,1.9,0,0,0,1.893,1.893h6.311A1.9,1.9,0,0,0,52.765,28.4V1.893A1.9,1.9,0,0,0,50.872,0ZM51.5,28.4a.632.632,0,0,1-.631.631H44.56a.632.632,0,0,1-.631-.631V1.893a.632.632,0,0,1,.631-.631h6.311a.632.632,0,0,1,.631.631V28.4Z",
    transform: "translate(-42.667)",
    fill: "#dbb200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_377",
    "data-name": "Grupo 377",
    transform: "translate(57.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M306.872,0H300.56a1.9,1.9,0,0,0-1.893,1.893V28.4a1.9,1.9,0,0,0,1.893,1.893h6.311a1.9,1.9,0,0,0,1.893-1.893V1.893A1.9,1.9,0,0,0,306.872,0Zm.631,28.4a.632.632,0,0,1-.631.631H300.56a.632.632,0,0,1-.631-.631V1.893a.632.632,0,0,1,.631-.631h6.311a.632.632,0,0,1,.631.631V28.4Z",
    transform: "translate(-298.667)",
    fill: "#dbb200"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.bddc0d3b65d8a390ddd74edcac7a923a.svg";
export { ForwardRef as ReactComponent };